import {TranslationObject} from '@colonist/i18n'
import {ProfileEditAjaxEndPoints} from '../profile/ProfileEditAjaxEndPoints'
import {UIProfileUsernameController} from '../ui_html/header/UIProfileUsernameController'
import {ViewPopup} from './ViewPopup'
import {UIPopupController} from './UIPopupController'
import {setElementOnClick} from '../ui_utils/DomUtils'
import {AudioManager, AudioType} from '@colonist/audio'

export class ViewPopupChangeOnlineUsername extends UIProfileUsernameController {
    private readonly continuationAction: () => void

    constructor(continuationAction: () => void) {
        super()

        this.continuationAction = continuationAction

        setElementOnClick(this.xButton, () => {
            AudioManager.play(AudioType.Click)
            this.removePopup()
            this.continuationAction()
        })

        this.setFocusStyles(this.input)
        this.show()
    }

    // eslint-disable-next-line class-methods-use-this
    async updateUsername(newUsername: string, shouldPurchaseIfNoAttemptsLeft: boolean = false) {
        const success = await ProfileEditAjaxEndPoints.updateUsername(newUsername, shouldPurchaseIfNoAttemptsLeft)
        if(!success) return
        this.showSuccessPopup(newUsername)
    }

    protected checkAction() {
        AudioManager.play(AudioType.Click)
        if(!this.inputLengthIsInRange()) return

        this.inputCheckAction(this.input.value)
    }

    protected showConfirmUsernameChangeWithAttemptsLeftPopup(username: string) {
        const body: TranslationObject = {
            key: 'strings:homePage.header.changeUsername.confirm.body',
            options: {count: this.state.usernameChangeAttemptsLeft - 1},
        }
        UIPopupController.create({key: 'strings:homePage.header.changeUsername.confirm.title'}, body,
            () => {
                void this.updateUsername(username, false)
            },
            () => undefined)
    }

    private showSuccessPopup(newUsername: string) {
        this.removePopup()

        const title: TranslationObject = {key: 'strings:storePage.success.success'}
        const body: TranslationObject = {
            key: 'strings:homePage.header.changeUsername.successDiscord',
            options: {
                username: newUsername,
            },
        }

        const successPopup = new ViewPopup(title, body, () => undefined, () => undefined, true, {showXButton: false})
        successPopup.removeAction = this.continuationAction
        successPopup.show()
    }
}
